<span>В обработке: {{ (activeProcesses$ | async)?.length }}</span>
